class PriceController {
    constructor(currencyFilter) {
        this.currencyFilter = currencyFilter;
    }

    $onInit() {
        this.buildDisplayPrice(this.price);
    }

    $onChanges(change) {
        this.buildDisplayPrice(change.price.currentValue);
    }

    buildDisplayPrice(price) {
        if (price === undefined) { return; }

        const displayPrice = this.currencyFilter(price);

        this.currencySymbol = displayPrice.slice(0, 1);
        [this.priceDollar, this.priceCents] = displayPrice.slice(1).split('.');
    }
}

const priceControllerComponentDefinition = {
    bindings: {
        price: '<',
        classModifier: '@?',
    },
    controller: ['currencyFilter', PriceController],
    template: `
        <div class="price" ng-class="::$ctrl.classModifier">
            <span class="price-symbol">{{ ::$ctrl.currencySymbol }}</span>
            <span class="price-dollars">{{ $ctrl.priceDollar }}</span>
            <span class="price-cents">{{ $ctrl.priceCents }}</span>
        </div>
    `,
};

module.exports = {
    PriceController,
    priceControllerComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/price/price.component.js